module.exports = __webpack_public_path__ + "img/icon-recepcion-w.63341167.svg";